import MCMain, {
    MainAccessManagementInnerRef,
} from 'modules/home/manage-access/content/Main';
import { ReactElement, useEffect, useRef, useState } from 'react';
import { HeadTag } from 'shared/components';
import { Box } from '@mui/system';

import MCHeaderMain from 'modules/home/manage-access/header/Main';

import { useLocation, useParams } from 'react-router-dom';

/**
 * ManageClientsPage component.
 * Renders the Manage Clients page.
 * @returns {ReactElement} ManageClientsPage component.
 */
const ManageClientsPage = (): ReactElement => {
    // The status page: view, add or edit

    const location = useLocation();
    const { clientId } = useParams();
    const innerMCBodyRef = useRef<MainAccessManagementInnerRef | null>(null);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [statusPage, setStatusPage] = useState<string>('view');

    useEffect(() => {}, [clientId, location.pathname]);
    return (
        <>
            <HeadTag title="Manage Access Management" />
            <Box className="ContainerAccessManagement">
                <Box
                    className={`${
                        statusPage !== 'view'
                            ? 'WrapperHeaderManageAccess action-view'
                            : 'WrapperHeaderManageAccess'
                    }`}
                >
                    <MCHeaderMain
                        onClickButtonMember={() => {
                            innerMCBodyRef.current?.showNewMemberModal();
                        }}
                    />
                </Box>

                {/* The content - View or Edit */}
                <Box className="manage-access-container">
                    <MCMain ref={innerMCBodyRef} />
                </Box>
            </Box>
        </>
    );
};

export default ManageClientsPage;
